import { render, staticRenderFns } from "./StudentVideoPlay.vue?vue&type=template&id=0bfaa1b0&scoped=true&"
import script from "./StudentVideoPlay.vue?vue&type=script&lang=js&"
export * from "./StudentVideoPlay.vue?vue&type=script&lang=js&"
import style0 from "./StudentVideoPlay.vue?vue&type=style&index=0&id=0bfaa1b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfaa1b0",
  null
  
)

export default component.exports